import { render, staticRenderFns } from "./EndIntro.vue?vue&type=template&id=984986cc&"
import script from "./EndIntro.vue?vue&type=script&lang=js&"
export * from "./EndIntro.vue?vue&type=script&lang=js&"
import style0 from "./EndIntro.vue?vue&type=style&index=0&id=984986cc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports